/* template */
<template minapp="mpx" xlang="wxml"><controllable-drawer-bottom title="请登录12306" :show="(show)" :headerStyle="(headerStyle)" :iconStyle="(iconStyle)" @close="closeLoginDrawer"><div class="card"><div class="card-description">铁路部门规定购买火车票需实名认证</div><div class="button-group"><login-drawer-button :buttonType="(1)" :amount="(offlineAmount)" @close="closeLoginDrawer" @check="check" @submit="submit" class="button"/><login-drawer-button :amount="(login12306Amount)" @close="closeLoginDrawer" @check="check" class="button"/></div></div></controllable-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m774f87ba"}'>
  .card
    margin-top 10px
    display flex
    flex-direction column
    padding 0 20px 49px 20px
    &-description
      font-family PingFangSC-Regular
      font-size 12px
      line-height 18px
      color #999999
      margin-bottom 16px
    .button-group
      display flex
      justify-content space-between
      .button 
        flex 1
        &:not(:last-child)
          margin-right 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m774f87ba"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./login-drawer.mpx.js?isComponent&outputPath=components%2Flogin-drawer774f87ba%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./login-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Flogin-drawer774f87ba%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m774f87ba"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/login-drawer774f87ba/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'login-drawer-button':getComponent(require("./login-drawer-button.mpx?isComponent&outputPath=components%2Flogin-drawer-button109bbf0a%2Findex")),'controllable-drawer-bottom':getComponent(require("../../../components/controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
